import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetSmsWorkflowList({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/sms_workflow/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page,
          per_page: list.per_page ? list.per_page : 10,
          sms_workflow_name: '*' + list.sms_workflow_name + '*'
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetSmsWorkflow({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_workflow/" + id,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err)
      });
    });
  },
  AddSmsWorkflow({ commit }, smsWorkflow) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_workflow",
        data: smsWorkflow,
        method: "POST"
      }).then(res => {
        resolve(res.data.payload);
      })
        .catch(err => {
          reject(err);
        });
    });
  },
  EditSmsWorkflow({ commit }, smsWorkflow) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/sms_workflow/" + smsWorkflow.id,
        data: smsWorkflow.smsWorkflow,
        method: "Patch"
      }).then(res => {
        resolve(res.data.payload);
      })
        .catch(err => {
          reject(err);
        });
    });
  },
  DeleteSmsWorkflow({ commit }, id) {
    return new Promise(resolve => {
      axios({
        url: "/sms_workflow/" + id,
        method: "DELETE"
      }).then(res => {
        resolve(res);
      });
    });
  },
  SendSmsWorkflow({ commit }, data) {
    return new Promise((resolve, reject) => {
      let url = "/sms";

      if (data.hasOwnProperty('checked') && data.checked) {
        delete data.checked;
        url = '/bulk';
      }

      if (data.hasOwnProperty('file') && data.file) {
        let formData = new FormData();
        formData.append("file", data.file);
        data = formData;
        url = '/bulk_sms';
      }

      // if (data.type == 'import') {
      //   let x = [];
      //   data.destinations.map((item) => {
      //     x.push(item.substring(0, item.length - 1))
      //   })
      //   data.destinations = x
      // }
      // delete data.type;
      // console.log(data)
      axios({
        url: url,
        method: "post",
        data: data,
      }).then(res => {
        resolve(res);
      }).catch(err => {
        resolve(err);
      });
    });
  },
};

// mutations
const mutations = {

};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
